import React from "react";
import { Link } from "react-router-dom";
import InquiryForm from "./InquiryForm";
import { trackEvent, EVENTS } from "@/utils/tracking";

// Light ivory/blush variant to prevent double-brown with footer
export default function FinalCTA() {
  return (
    <section data-testid="final-cta" className="relative bg-[#FAF6F1] text-[#3B312D] overflow-hidden border-t border-[rgba(182,89,128,0.12)]">
      <div className="absolute inset-0 opacity-45" style={{
        backgroundImage:
          "radial-gradient(circle at 12% 20%, rgba(182,89,128,0.18), transparent 45%), radial-gradient(circle at 85% 80%, rgba(138,154,123,0.16), transparent 50%), radial-gradient(circle at 60% 10%, rgba(197,160,89,0.10), transparent 45%)"
      }} />
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-32 grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5">
          <span className="pill-rose">Begin Your Celebration</span>
          <h2 className="font-display text-4xl md:text-6xl leading-[1.05] mt-6 text-[#3B312D]">
            Let's design something <span className="italic text-[#B65980]">unforgettable</span>.
          </h2>
          <p className="mt-6 text-[16px] text-[#3B312D]/80 max-w-md leading-relaxed">
            Whether it's an intimate gathering, a multi-day wedding, a corporate launch, or a
            devotional evening, we begin with a calm, no-pressure conversation about your vision.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link to="/contact" className="btn-primary" data-testid="cta-plan-event" onClick={() => trackEvent(EVENTS.PLAN_EVENT_CTA_CLICK, { location: "final-cta" })}>Plan Your Celebration</Link>
            <Link to="/services" className="btn-ghost" data-testid="cta-explore-services">Explore Services</Link>
          </div>
        </div>
        <div className="lg:col-span-7">
          <InquiryForm compact source="final-cta" />
        </div>
      </div>
    </section>
  );
}
